import React from 'react';
import { Link } from 'react-router-dom';
import './index.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">页面未找到</p>
      <p className="not-found-description">您没有权限访问此页面或页面不存在</p>
      <Link to="/" className="back-home-link">返回首页</Link>
    </div>
  );
};

export default NotFoundPage;